import { render } from "./ReviewList.vue?vue&type=template&id=b439987a&scoped=true"
import script from "./ReviewList.vue?vue&type=script&lang=js"
export * from "./ReviewList.vue?vue&type=script&lang=js"

import "./ReviewList.vue?vue&type=style&index=0&id=b439987a&scoped=true&lang=css"
import "./ReviewList.vue?vue&type=style&index=1&id=b439987a&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b439987a"]])

export default __exports__